import apiUrls from "../urls";

export default function (api) {
	return {
		postData(data) {
			console.log("🌐 [API] Отправка запроса на:", apiUrls.UPLOAD_ORDER);
			console.log("🌐 [API] Headers:", {
				"Content-Type": "multipart/form-data",
			});

			return api
				.post(apiUrls.UPLOAD_ORDER, data, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(response => {
					console.log("🌐 [API] Ответ получен:", {
						status: response.status,
						data: response.data,
					});
					return response;
				})
				.catch(error => {
					console.error("🌐 [API] Ошибка запроса:", {
						status: error.response?.status,
						data: error.response?.data,
						message: error.message,
					});
					throw error;
				});
		},
	};
}
